module.exports = __webpack_public_path__ + "media/ko_kr_s1_ChinSun.8b4da24d.oga";